import {
  Document,
  View,
  Page,
  Text,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import imgHt from "../../imagenes/imgHt.png";
import { format } from "date-fns";

export default function DetailPresupuestoPDF({key, id, presupuesto, bruto}) {
    let date = format(new Date(), "yyyy/MM/dd"); 
      
    //console.log(presupuesto);
    console.log(id)
    console.log(bruto);
    console.log(presupuesto);
    
    
  
       
    return (
                      
      <PDFViewer style={{ width: "118vh", height: "90vh" }}>
        <Document>
          <Page size="A4" style={{display:"flex"}}>
          
            <View style={{display:"flex"}}>
              <View style={{ display: "flex"}}>
                <View
                  style={{
                    widt: "200px",
                    height: "125px",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
            
                  <View style={{ marginLeft: "40px" }}>
                    
                    <Image
                      href={imgHt}
                      style={{ width: "100px", height: "60px" }}
                    />
                    <View style={{ marginLeft: "11px" }}>
                     
                      <Text style={{ fontSize: "9pt" }}>Grupo HT</Text>
                      <Text style={{ fontSize: "9pt" }}>Pedro Lozano 5066</Text>
                      <Text style={{ fontSize: "9pt" }}>CABA</Text>
                      <Text style={{ fontSize: "9pt" }}>Argentina</Text>
                      <Text style={{ fontSize: "9pt" }}>Tel: 15-57619270</Text>
                      <Text style={{ fontSize: "9pt" }}>CUIT: </Text>
                    </View>
                  </View>
                  <View style={{ marginTop: "40px", marginRight: "40px" }}>
                   
                    <Text>Remito</Text>
                    <Text style={{ fontSize: "14pt" }}>
                      N°: 0001- {presupuesto.numberDocument}
                    </Text>
                    <Text> </Text>
                    <Text style={{ fontSize: "9pt" }}>
                      Fecha de Emisión: {date}
                    </Text>
                  </View>
                </View>
  
                <View>
                  <View
                    style={{
                      width: "530px",
                      height: "50px",
                      borderTop: "1px",
                      borderColor: "grey",
                      flexDirection:"row",
                      paddingTop:"5px",
                      marginLeft:"30px",                    
                    }}
                  > 
                    <View style={{ flexDirection: "column", marginLeft:"10px", width:"185px"}}>
                      <Text style={{ fontSize: "9pt" }}>Compañia: {presupuesto.client_id.nameCompany}</Text>
                      <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Direccion: {presupuesto.client_id.address}</Text>
                    </View>
                    <View style={{marginLeft: "40px", width:"185px"}}>
                      <Text style={{ fontSize: "9pt" }}>Nombre: {presupuesto.client_id.name}</Text>
                      <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Telefonos: {presupuesto.client_id.telephoneNumber}</Text>
                    </View>
                    <View style={{marginLeft:"50px", width:"185px", marginRight:"5px"}}>
                      <Text style={{ fontSize: "9pt" }}>Apellido: {presupuesto.client_id.lastName}</Text>
                      <Text style={{ fontSize: "9pt", paddingTop:"5px"}}>Email: {presupuesto.client_id.email}</Text>
                    </View>
                  </View>
  
                  <View style={{width:"530px", height:"25px", borderTop:"1px", borderBottom:"1px", borderColor:"grey", flexDirection:"row", paddingTop:"5px", marginLeft:"30px"}}>
                    <View style={{maxWidth:"185px", minWidth:"185px", boder:"1px", borderColor:"black", marginLeft:"50px"}}>
                    <Text style={{ fontSize: "9pt"}}>
                      Dir. Evento: {presupuesto.addressEvent}
                    </Text>
                    </View>
                    <View style={{width:"185px"}}>
                    <Text style={{ fontSize: "9pt"}}>
                      Fecha Envio:{" "}
                      {format(new Date(presupuesto.dateSend), "dd/MM/yyyy")}
                    </Text>
                    </View>
                    <View style={{width:"185px"}}>
                    <Text style={{ fontSize: "9pt"}}>
                      Fecha Retorno:{" "}
                      {format(new Date(presupuesto.dateReception), "dd/MM/yyyy")}
                    </Text>
                    </View>
                  </View>

                    {bruto === false ?
                    <View>
                    <View style={{height:"20px", display:"flex", marginLeft:"30px", width:"530px"}}>
                      <Text style={{fontSize:"12pt", paddingTop:"5px"}}>Articulos</Text>
                    </View>
                    <View style={{display:"flex", flexDirection:"row", width:"530px", paddingTop:"5px", 
                                  paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px", fontSize:"11pt"}}>
                      <Text style={{width:"130px", paddingLeft:"5px"}}>Nombre</Text>
                      <Text style={{width:"300px"}}>Descripcion</Text>
                      <Text style={{width:"30px"}}>Un.</Text>
                      <Text style={{width:"50px"}}>Precio Un.</Text>
                      <Text style={{width:"50px"}}>Importe Total</Text>
                    </View>
                    <View style={{marginLeft:"30px"}}>
                      {presupuesto.quantityItems.map(e=>
                        <View style={{display:"flex", flexDirection:"row", width:"530px", height:"15px", borderBottom:"1px", borderColor:"black", alignItems:"center"}}>                        
                          <Text style={{width:"130px", borderColor:"black", borderLeft:"1px", paddingLeft:"5px", borderRight:"1px", fontSize:"9pt"}}>{e.name}</Text>                        
                          <Text style={{width:"300px", borderRight:"1px", fontSize:"9pt"}}>{e.descrip}</Text>                        
                          <Text style={{width:"30px", justifyContent:"center", borderRight:"1px", borderColor:"black", paddingRight:"2px", fontSize:"9pt", textAlign:"right"}}>{e.presupuesto}</Text>                        
                          <Text style={{width:"50px", alignContent:"center", borderRight:"1px", borderColor:"black", fontSize:"9pt", textAlign:"right", paddingRight:"2px"}}>{e.price}</Text>                        
                          <Text style={{width:"50px", alignContent:"center", borderRight:"1px", borderColor:"black", fontSize:"9pt", textAlign:"right", paddingRight:"2px"}}>{e.totalPrice}</Text>                        
                        </View>
                      )}
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontSize:"10pt", justifyContent:"space-between", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px", marginTop:"30px"}}>                    
                      <Text style={{width:"100px", marginLeft:"5px"}}>Subtotal</Text>
                      <Text style={{width:"300px", textAlign:"right"}}>{presupuesto.subtotal}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontSize:"10pt", justifyContent:"space-between", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px", marginTop:"2px"}}>                    
                      <Text style={{width:"100px", marginLeft:"5px"}}>Subtotal Presupuesto</Text>
                      <Text style={{width:"300px", textAlign:"right"}}>{presupuesto.subTotalPresupuesto}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px"}}>
                          <Text style={{width:"150px", marginLeft:"5px"}}>Coeficiente</Text>
                          <Text style={{width:"100px", textAlign:"right"}}>{presupuesto.coeficiente}</Text>
                          <Text style={{width:"300px", textAlign:"right"}}>Total * Coeficiente</Text>
                          <Text style={{width:"300px", textAlign:"right"}}>{presupuesto.totalCoeficiente} </Text>                         
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Item 1 - <Text>{presupuesto.item1.clave}: </Text>{presupuesto.item1.valor}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Item 2 - <Text>{presupuesto.item2.clave}: </Text>{presupuesto.item2.valor}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Item 3 - <Text>{presupuesto.item3.clave}: </Text>{presupuesto.item3.valor}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Item 4 - <Text>{presupuesto.item4.clave}: </Text>{presupuesto.item4.valor}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Total Items - <Text>{presupuesto.item1.valor + presupuesto.item2.valor + presupuesto.item3.valor + presupuesto.item4.valor}</Text></Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Total - <Text>{presupuesto.totalDocumento}<Text style={{fontSize:"8pt"}}>+iva</Text></Text></Text>
                      </View>
                      </View> 
                    :
                    <View>
                    <View style={{height:"20px", display:"flex", marginLeft:"30px", width:"530px"}}>
                      <Text style={{fontSize:"12pt", paddingTop:"5px"}}>Articulos</Text>
                    </View>
                    <View style={{display:"flex", flexDirection:"row", width:"530px", paddingTop:"5px", 
                                  paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px", fontSize:"11pt"}}>
                      <Text style={{width:"130px", paddingLeft:"5px"}}>Nombre</Text>
                      <Text style={{width:"430px"}}>Descripcion</Text>
                      <Text style={{width:"30px"}}>Un.</Text>
                      {/* <Text style={{width:"50px"}}>Precio Un.</Text>
                      <Text style={{width:"50px"}}>Importe Total</Text> */}
                    </View>
                    <View style={{marginLeft:"30px"}}>
                      {presupuesto.quantityItems.map(e=>
                        <View style={{display:"flex", flexDirection:"row", width:"530px", height:"15px", borderBottom:"1px", borderColor:"black", alignItems:"center"}}>                        
                          <Text style={{width:"130px", borderColor:"black", borderLeft:"1px", paddingLeft:"5px", borderRight:"1px", fontSize:"9pt"}}>{e.name}</Text>                        
                          <Text style={{width:"430px", borderRight:"1px", fontSize:"9pt"}}>{e.descrip}</Text>                        
                          <Text style={{width:"30px", justifyContent:"center", borderRight:"1px", borderColor:"black", paddingRight:"2px", fontSize:"9pt", textAlign:"right"}}>{e.presupuesto}</Text>                        
                         
                        </View>
                      )}
                      </View>
                     
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px", marginTop:"10px"}}>
                        <Text style={{width:"350px", marginLeft:"5px"}}></Text>
                        <Text style={{width:"300px", textAlign:"right"}}>Total</Text>
                        <Text style={{width:"300px", textAlign:"right"}}>{presupuesto.totalDocumento} </Text>                         
                      </View>
                      {/* <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Item 1 - <Text>{presupuesto.item1.clave}: </Text>{presupuesto.item1.valor}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Item 2 - <Text>{presupuesto.item2.clave}: </Text>{presupuesto.item2.valor}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Item 3 - <Text>{presupuesto.item3.clave}: </Text>{presupuesto.item3.valor}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Item 4 - <Text>{presupuesto.item4.clave}: </Text>{presupuesto.item4.valor}</Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Total Items - <Text>{presupuesto.item1.valor + presupuesto.item2.valor + presupuesto.item3.valor + presupuesto.item4.valor}</Text></Text>
                      </View>
                      <View style={{display:"flex", flexDirection:"row", width:"530px", fontWeight:"bold", fontSize:"10pt", paddingTop:"5px", paddingBottom:"4px", borderBottom:"1px", borderColor:"grey", marginLeft:"30px"}}>
                        <Text style={{marginLeft:"5px"}}>Total - <Text>{presupuesto.totalDocumento}<Text style={{fontSize:"8pt"}}>+iva</Text></Text></Text>
                      </View> */}
                      </View> 
                    }
                    
                </View>
              </View>
            </View>            
          </Page>
        </Document>
      </PDFViewer>      
     );
  }